import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './pc-button.css.lit';

import '../pc-icon/pc-icon';

type ButtonVariant = 'primary' | 'secondary';

/**
 * Button component
 * @element pc-button
 * @slot - This element has a default slot
 */
@customElement('pc-button')
export class PCButton extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  @property()
  variant: ButtonVariant;

  @property()
  href: string;

  @property()
  target = '_self';

  render(): TemplateResult {
    const buttonClasses = {
      btn: true,
      [this.variant]: true,
    };

    if (this.href) {
      return html`
        <a
          href=${this.href}
          target=${this.target}
          class=${classMap(buttonClasses)}
        >
          <slot></slot>
          <pc-icon name="arrow-right"></pc-icon>
        </a>
      `;
    }

    return html`
      <button class=${classMap(buttonClasses)}>
        <slot></slot>
        <pc-icon name="arrow-right"></pc-icon>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-button': PCButton;
  }
}
